import { useEffect, useState } from "react";
import { useUI } from "@/lib/theme";

// Código Konami: ↑ ↑ ↓ ↓ ← → ← → B A
const SEQ = [
  "ArrowUp",
  "ArrowUp",
  "ArrowDown",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  "ArrowLeft",
  "ArrowRight",
  "b",
  "a",
];

/** Easter egg: al teclear el código Konami aparece la Champi de la suerte. */
export default function KonamiEgg() {
  const { t } = useUI();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let idx = 0;
    const onKey = (e: KeyboardEvent) => {
      const k = e.key.length === 1 ? e.key.toLowerCase() : e.key;
      if (k === SEQ[idx]) {
        idx += 1;
        if (idx === SEQ.length) {
          idx = 0;
          setOpen(true);
        }
      } else {
        // Reinicia; si la tecla coincide con el inicio del código, cuenta como paso 1.
        idx = k === SEQ[0] ? 1 : 0;
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  useEffect(() => {
    if (!open) return;
    const onEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", onEsc);
    return () => window.removeEventListener("keydown", onEsc);
  }, [open]);

  if (!open) return null;
  return (
    <div
      onClick={() => setOpen(false)}
      role="dialog"
      aria-label="Champi"
      className="fixed inset-0 z-50 flex flex-col items-center justify-center gap-4 bg-black/80 p-6 backdrop-blur-sm"
    >
      <p className="max-w-xl text-center text-xl font-extrabold leading-snug text-white drop-shadow-lg sm:text-2xl">
        🍀 {t("egg_msg")}
      </p>
      <img
        src="/champi.png"
        alt="Champi"
        className="max-h-[68vh] w-auto rounded-2xl border-4 border-white/80 shadow-2xl"
      />
      <p className="text-xs text-white/70">{t("egg_close")}</p>
    </div>
  );
}
